import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/colosePopup.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: 0,
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    maxWidth: 820,
    width: '100%',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '4px 24px 24px 24px',
  },
  title: {
    color: '#181818',
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 600,
  },
  subTitle: {
    color: '#5E5E5E',
    fontFamily: 'Inter, sans-serif',
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 12,
    marginBottom: 16,
    borderBottom: '1px solid #DFE4EB',
    '& input': {
      width: 36,
      height: 36,
      borderRadius: 999,
      background: '#F2F2F2',
      boxSizing: 'border-box',
    },
  },
  body: {
    overflowY: 'auto',
    paddingRight: 4,
  },
  typeHead: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 700,
    color: '#1B3963',
    marginBottom: 5,
  },
  typeDetail: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    color: '#475569',
    '& b': {
      fontWeight: 700,
      color: '#1B3963',
    },
  },
})

const FundamentalCreditTooltipModal = ({
  open,
  setOpen,
  handleClose,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={false}
        PaperProps={{ style: { maxWidth: 820, width: '100%' } }}
      >
        <DialogContent>
          <div className={classes.content}>
            {!isMobile && (
              <div className={classes.header}>
                <div>
                  <span className={classes.title}>
                    Fundamental - Credit Analysis
                  </span>
                  <span className={classes.subTitle}>
                    (Fair value-based credit assessment)
                  </span>
                </div>
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            {isMobile && (
              <>
                <div className={classes.header} style={{ marginBottom: 5 }}>
                  <div>
                    <span className={classes.title}>
                      Fundamental - Credit Analysis
                    </span>
                    <span className={classes.subTitle}>
                      (Fair value-based credit assessment)
                    </span>
                  </div>
                  <input
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
              </>
            )}
            <div className={classes.body}>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>Credit View: </p>
                <p className={classes.typeDetail}>
                  As part of the fundamentals view of a company we provide this
                  specific credit view of a company. You will find an implied
                  rating, a trend (positive, stable and negative) to that
                  rating, a specific forward looking credit outlook (High,
                  Medium, Low, Neutral), a credit stress measure (proxy for
                  distance to downgrade) and a view of the underlying drivers of
                  that credit stress measure credit view. We will rate companies
                  using the following ratings buckets; AA, A, BBB, BB, B and
                  CCC.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeDetail}>
                  Contrary to incumbent structural models in the market which
                  dampen volatility and institute very tight bands around credit
                  stress measure, we reflect the true state of the firm. We
                  create much more accurate classification of the credit
                  situation of an issuer and do not issue a large swathe of
                  false positives unlike other providers.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>Credit Outlook: </p>
                <p className={classes.typeDetail}>
                  The industries first forward looking credit risk status, this
                  brings together the full capital structure view of the company
                  to identify a level of unrecognised risk. The rating, credit
                  stress measure, rating trend, forward looking equity risk all
                  become key contributors to the credit risk outlook.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>Implied rating: </p>
                <p className={classes.typeDetail}>
                  Rating agencies often lag in incorporating recent market and
                  fundamental developments to accurately update their views in
                  time. This is especially pronounced in segments of issuers
                  which are new to the market, trade with wide spreads or
                  operate in emerging economies like China. We present a
                  solution which aggregates issuance specific information to
                  impute issuer’s credit rating at times when observations are
                  sparse. This enables you to anticipate future potential
                  ratings changes and act in a more timely manner.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>
                  Improving relationship between the credit stress measure (CSM)
                  and the reality of the companies rating:
                </p>
                <p className={classes.typeDetail}>
                  The automated Implied Credit Rating provides unrestricted,
                  unbiased and uninterrupted assessment of credit risk. It is
                  unrestricted by any commercial agreement as long as the
                  underlying data are available. It is unbiased as it systemizes
                  a multitude of company risk patterns, not relying just on
                  narrow default scenarios. It is uninterrupted, as a rating
                  change is generated as soon as new information is presented
                  without the typical delay at the traditional rating agencies.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>Implied rating trend:</p>
                <p className={classes.typeDetail}>
                  The rating trend is a modelling of momentum of the Credit
                  stress measure (distance to downgrade) to deliver to you the
                  trend direction of the implied rating. This will allow you to
                  make a view if the rating is stable or moving in a negative or
                  positive trend.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>Credit stress measure: </p>
                <p className={classes.typeDetail}>
                  This is a percentage measure of the probability a firm will
                  default over the next 12 months. The higher the percentage the
                  worse the credit outlook for the firm is and vis-a-versa the
                  lower the better the credit situation.
                </p>
              </div>
              <div className={classes.detailContent}>
                <p className={classes.typeHead}>Credit and Equity Together:</p>
                <p className={classes.typeDetail}>
                  Using chart 1 below you can overlay both equity and credit
                  together, a valuable way to assess a 360 view of the company.
                  This can also be viewed in relation to the other panels on the
                  interface, to give a full picture of the company including the
                  level of unrecognised risk over the medium term.
                </p>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(FundamentalCreditTooltipModal)
